import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import createComponent from '@ycos/fela/src/createComponent'
import merge from 'lodash/merge'

const GridOuterRow = createComponent(
  'GridOuterRow',
  ({ theme, additionalOuterStyles }) =>
    merge(
      {
        clear: 'both',
        margin: '0 auto',
        position: 'relative',
        maxWidth: `${theme.breakpoints.xlarge.width}px`
      },
      additionalOuterStyles
    ),
  'div'
)

const GridInnerRow = createComponent(
  'GridInnerRow',
  ({ additionalStyles, verticallyCenter, fullBleedConf, theme }) =>
    merge(
      {
        boxSizing: 'border-box',
        display: 'flex',
        flex: '0 1 auto',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: verticallyCenter ? 'center' : 'stretch',
        padding: '0 0',
        position: 'relative',
        marginLeft: `${fullBleedConf.fullBleed || fullBleedConf.small ? 0 : theme.breakpoints.small.marginOuter - theme.breakpoints.small.gutterWidth}px`,
        width: fullBleedConf.fullBleed || fullBleedConf.small ? '100%' : `calc(100% - ${2 * theme.breakpoints.small.marginOuter}px + ${theme.breakpoints.small.gutterWidth}px)`,
        ...getAllBreakpointsStyle(theme.breakpoints, fullBleedConf)
      },
      additionalStyles
    ),
  'div'
)

const getAllBreakpointsStyle = (breakpoints, fullBleedConf) =>
  Object.values(breakpoints).reduce(
    (accumulator, breakpoint) => ({
      ...accumulator,
      ...getBreakpointStyle(breakpoint, fullBleedConf)
    }),
    {}
  )

const getBreakpointStyle = (breakpoint, fullBleedConf) => {
  return (
    breakpoint.name.toLowerCase() !== 'small' && {
      [`screen-${breakpoint.name.toLowerCase()}`]: {
        marginLeft: `${fullBleedConf.fullBleed || fullBleedConf?.[breakpoint.name.toLowerCase()] ? 0 : breakpoint.marginOuter - breakpoint.gutterWidth}px`,
        width: fullBleedConf.fullBleed || fullBleedConf?.[breakpoint.name.toLowerCase()] ? '100%' : `calc(100% - ${2 * breakpoint.marginOuter}px + ${breakpoint.gutterWidth}px)`
      }
    }
  )
}

class GridRow extends PureComponent {
  render() {
    const { additionalStyles, additionalOuterStyles, children, verticallyCenter, fullBleedConf = {}, fullBleed } = this.props
    return (
      <GridOuterRow additionalOuterStyles={additionalOuterStyles}>
        <GridInnerRow additionalStyles={additionalStyles} verticallyCenter={verticallyCenter} fullBleedConf={{ ...fullBleedConf, fullBleed }}>
          {children}
        </GridInnerRow>
      </GridOuterRow>
    )
  }
}

GridRow.defaultProps = {
  additionalStyles: {},
  additionalOuterStyles: {},
  verticallyCenter: false
}

GridRow.propTypes = {
  children: PropTypes.node,
  additionalStyles: PropTypes.object,
  additionalOuterStyles: PropTypes.object,
  verticallyCenter: PropTypes.bool
}

export default GridRow
